import { PdfViewer } from '@components';
import { Button, Container, Dropdown, Typography } from '@design-system';
import './PPSPSPage.scss';
import { usePPSPSPageVM } from './usePPSPSPageVM';

export const PPSPSPage: React.FC = () => {
    const {
        operatorsOptions,
        worksitesOptions,
        selectedOperatorId,
        selectedWorksiteId,
        handleOperatorChange,
        setSelectedWorksiteId,
        areInputsFilled,
        ppsps,
        isPpspsVisible,
        handleVisualizePpsps,
        handleClosePpsps
    } = usePPSPSPageVM();

    return (
        <div className="ppsps-page">
            <Container>
                <Container className="worksite-infos" bordered="grey">
                    <Typography intrinsic="h4" defaultSpacing>
                        Sélectionnez un chantier
                    </Typography>

                    <Container padding="none" className="worksite-infos-inputs">
                        <Dropdown
                            options={operatorsOptions}
                            placeholder="Responsable"
                            onOptionChange={(option) => handleOperatorChange(option.id)}
                            value={operatorsOptions.find((operator) => operator.id === selectedOperatorId)}
                        />

                        <Dropdown
                            options={worksitesOptions}
                            placeholder="Chantier"
                            onOptionChange={(option) => setSelectedWorksiteId(option.id)}
                            value={
                                selectedWorksiteId && worksitesOptions.length > 0
                                    ? worksitesOptions.find((worksite) => worksite.id === selectedWorksiteId) || null
                                    : null
                            }
                            isSearchable={true}
                        />
                    </Container>
                </Container>

                <Button
                    color="blue"
                    variant="secondary"
                    size="small"
                    onClick={handleVisualizePpsps}
                    className="mt-medium-spacing centered"
                    disabled={!areInputsFilled}
                >
                    <Typography intrinsic="h4">Visualiser le PPSPS</Typography>
                </Button>
                <div className="ppsps-viewer-container">
                    {ppsps && isPpspsVisible && (
                        <PdfViewer
                            file={ppsps.pdf_url}
                            setHasSeenAllPages={() => {}}
                            bottomBarPagination
                            callbackOnLastPage={handleClosePpsps}
                            labelNextButtonOnLastPage="Fermer le PPSPS"
                        />
                    )}
                </div>
            </Container>
        </div>
    );
};
